
import React, { useState } from "react";
import "../assets/css/card.css";
import { useCart } from "../context/CartContext";
import ModalPic from "../assets/images/modal.png";
import { NotificationManager } from "react-notifications";
import ViewModal from '../assets/images/viewmodal.webp'

const SecondCard = ({ title, items = {}, index, image }) => {
  const [chosenPlan, setChosenPlan] = useState(null);
  const { addToCart } = useCart();
  const [isHovered, setIsHovered] = useState(false);
  const [loading, setLoading] = useState(false);
  const [quantity, setQuantity] = useState(1);

  const modalId = `modal-${index}-${title.replace(/\s+/g, "-")}`;
  const description = items?.description || "";
  const packageItems = Array.isArray(items?.plans) ? items.plans : [];



  const startingPrice = items?.starting_price || null;

  // ✅ booking flag
  const allowBooking = items?.booking === true;

  const handleChoose = async () => {
    if (!chosenPlan) return;

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        NotificationManager.warning("Please login first!");
        setLoading(false);
        return;
      }

      let price = chosenPlan.price;

      if (typeof price === "string" && isNaN(Number(price))) {
        NotificationManager.warning("This plan requires a custom quote. Please contact support.");
        setLoading(false);
        return
      }

      price = Number(price) || 0;

      const itemToAdd = {
        service: title,
        ...chosenPlan,
        quantity,
        total: price * quantity,
      };

      const bookingPayload = {
        note: JSON.stringify(itemToAdd),
        price: Number(itemToAdd.price || 0) * quantity,
      };

      const res = await fetch(
        `${process.env.REACT_APP_HOST_API_URL}/api/booking/add/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(bookingPayload),
        }
      );

      const data = await res.json();

      if (data.status !== 200) {
        NotificationManager.error(data.message || "Booking failed");
        setLoading(false);
        return;
      }

      const bookingId = data.data.id;

      addToCart({ ...itemToAdd, bookingId });

      // const existingCart = JSON.parse(localStorage.getItem("cart")) || [];
      // existingCart.push({ ...itemToAdd, bookingId });
      // localStorage.setItem("cart", JSON.stringify(existingCart));

      NotificationManager.success("Service Added to Cart");
      setLoading(false);
    } catch (err) {
      console.error("Booking error:", err);
      NotificationManager.error("Something went wrong!");
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="card rounded d-flex flex-column mx-auto container "
        style={{
          width: "100%",
          maxWidth: "260px",
          minHeight: "400px",
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.27), rgba(0, 0, 0, 0.32)), url(${image})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          filter:
            window.innerWidth > 768
              ? isHovered
                ? "none"
                : "grayscale(100%)"
              : "none",
          transform: isHovered ? "scale(1.10)" : "scale(1)",
          // boxShadow: isHovered
          //   ? "0 0 25px rgba(255,215,0,0.9), 0 0 50px rgba(255,255,255,0.7)"
          //   : "0 2px 6px rgba(0,0,0,0.3)",
          transition: "all 0.3s ease",
          borderRadius: "10px",
          cursor: "pointer",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="content p-4 flex-grow-1 ">
          <div className="secondtitle text-center">{title}</div>
          <div className="price h3 text-center fw-bold">
            {/* {minPrice ? `$${minPrice}` : "--"} */}
            {startingPrice ? `$${startingPrice}` : "--"}
          </div>
          {description && (
            <div
              className="text-center text-white mt-3"
              style={{
                wordWrap: "break-word",
                whiteSpace: "normal",
              }}
            >

              {description}{" "}
              {startingPrice && (
                <strong>Starting from ${startingPrice}</strong>
              )}
            </div>
          )}
        </div>
        <div className="action mt-auto text-center">
          <button
            type="button"
            className="btn btn-outline-light w-100 py-2 rounded-1"
            data-bs-toggle="modal"
            data-bs-target={`#${modalId}`}
            onClick={() => {
              setChosenPlan(null)
              setQuantity(1)
            }}
          >
            {allowBooking ? "Choose Package" : "View Details"}
          </button>
        </div>
      </div>

      {/* ✅ Booking Modal */}
      {allowBooking ? (
        <div
          className="modal fade mt-5"
          id={modalId}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby={`${modalId}Label`}
          aria-hidden="true"
          data-bs-scroll="true"
          style={{ height: "90vh" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              {/* <div className="modal-header sticky-top ">
                <h1 className="modal-title fs-5" id={`${modalId}Label`}>
                  Book your {title}
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div> */}
              <div className="p-2 text-center mt-5">
                <h3>{title}</h3>
              </div>

              <div>
                <h1
                  className="text-center px-4"
                  style={{ color: "#0564bf" }}
                >
                  {/* {chosenPlan?.price ? `$${chosenPlan.price}` : ""} */}
                  {chosenPlan && !isNaN(Number(chosenPlan.price))
                    ? `$${Number(chosenPlan.price) * (quantity || 1)}`
                    : ""}
                </h1>
              </div>
              <div
                className="modal-body position-relative"
                style={{
                  backgroundImage: `url(${ModalPic})`,
                  backgroundPosition: "bottom",
                  minWidth: "100%",
                  height: "70vh",
                  backgroundSize: "cover",
                }}
              >
                <label className="fw-bold mb-2">Select a plan:</label>
                <select
                  className="form-select"
                  value={chosenPlan ? packageItems.indexOf(chosenPlan) : ""}
                  onChange={(e) =>
                    setChosenPlan(packageItems[parseInt(e.target.value)])
                  }
                >
                  <option value="">-- Choose a plan --</option>
                  {packageItems.map((plan, idx) => (
                    <option key={idx} value={idx}>
                      {plan.frequency ||
                        plan.hours ||
                        plan.roomSize ||
                        plan.type ||
                        plan.size ||
                        plan.package ||
                        ""}
                      {plan.sessions ? ` - ${plan.sessions}` : ""}
                      {plan.standard ? ` - Std: $${plan.standard}` : ""}
                      {plan.deep ? ` - Deep: $${plan.deep}` : ""}
                      {plan.price ? `  $${plan.price}` : ""}
                      {plan.cleaning ? ` ${plan.cleaning}` : ""}
                      {plan.duration ? ` ${plan.duration}` : ""}
                    </option>
                  ))}
                </select>

                {chosenPlan && (
                  <div
                    className="alert alert-info mt-3"
                    style={{
                      opacity: 0.9,
                      backgroundColor: "white",
                      color: "black",
                    }}
                  >
                    <strong>Selected Plan:</strong>
                    <ul className="mb-0">
                      {Object.entries(chosenPlan).map(([key, value]) => (
                        <li key={key}>
                          {key.charAt(0).toUpperCase() + key.slice(1)}:{" "}
                          {typeof value === "object"
                            ? JSON.stringify(value)
                            : value}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {items.terms_and_conditions && (
                  <div
                    className="alert alert-info mt-5"
                    style={{
                      opacity: 0.95,
                      backgroundColor: "white",
                      color: "black",
                    }}
                  >
                    <h5 className="fw-bold text-danger">
                      {" "}
                      Terms & Conditions
                    </h5>
                    <p className="text-muted">{items.terms_and_conditions}</p>
                  </div>
                )}
              </div>

              <div className="modal-footer sticky-bottom d-flex flex-wrap align-items-center justify-content-between">

                {/* Qty selector */}
                {chosenPlan && (
                  <div className="d-flex align-items-center mb-2 mb-md-0">
                    <label className="small me-2 mb-0">Qty:</label>
                    <div className="input-group" style={{ width: "110px" }}>
                      <button
                        className="btn btn-outline-danger border-0"
                        type="button"
                        onClick={() =>
                          setQuantity((prev) => (prev > 1 ? prev - 1 : 1))
                        }
                      >
                        -
                      </button>
                      <input
                        type="text"
                        className="form-control text-center border-0"
                        value={quantity}
                        readOnly
                      />
                      <button
                        className="btn btn-outline-success border-0"
                        type="button"
                        onClick={() => setQuantity((prev) => prev + 1)}
                      >
                        +
                      </button>
                    </div>
                  </div>
                )}
                <div className="d-flex ms-auto gap-1">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={!chosenPlan || loading}
                    onClick={handleChoose}
                    data-bs-dismiss="modal"
                  >
                    {loading ? "Booking..." : "Add to Cart"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        /* ✅ View-Only Detail Modal */
        <div
          className="modal fade"
          id={modalId}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby={`${modalId}Label`}
          aria-hidden="true"
          data-bs-scroll="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              {/* <div className="modal-header sticky-top ">
                <h1 className="modal-title fs-5" id={`${modalId}Label`}>
                  {title} - Details
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div> */}
              <div
                className="modal-body position-relative"
                style={{
                  backgroundImage: `url(${ViewModal})`,
                  backgroundPosition: "top",
                  minWidth: "100%",
                  height: "70vh",
                  backgroundSize: "cover",
                  position: "relative",
                  zIndex: 1056
                }}
              >
                <h2>{title}</h2>
                {description && (
                  <p className="text-muted mb-5">{description}</p>
                )}
                <div className="row g-3">
                  {packageItems.map((plan, idx) => (
                    <div key={idx} className="col-12 col-lg-6">
                      <div className="alert alert-info rounded-0 shadow border-0"
                        style={{
                          // overflow: "hidden",
                          // borderRadius: "10px",
                          color: "black",
                          // border: "1px solid rgba(30, 24, 24, 0.3)",
                          backgroundColor: "rgba(255,255,255,0.9)", // semi-transparent background
                          // backdropFilter: "blur(10px)", // only the background is blurred
                        }}
                      >
                        <h6 className="fw-bold  position-relative" style={{ zIndex: 1 }}>
                          {plan.frequency ||
                            plan.hours ||
                            plan.roomSize ||


                            plan.package ||
                            ""}
                        </h6>
                        <p className="mb-1">
                          {plan.sessions ? `Sessions: ${plan.sessions}` : ""}
                        </p>

                        {plan.size && (
                          <p className="mb-1">Size: {plan.size}</p>
                        )}
                        {plan.type && (
                          <p className="mb-1">Type: {plan.type}</p>
                        )}
                        <p className="mb-1">
                          {plan.price ? `Price: $${plan.price}` : ""}
                        </p>
                        {plan.standard && (
                          <p className="mb-1">Standard: ${plan.standard}</p>
                        )}
                        {plan.deep && (
                          <p className="mb-1">Deep: ${plan.deep}</p>
                        )}

                      </div>
                    </div>
                  ))}
                </div>

                {items.terms_and_conditions && (
                  <div
                    className="alert position-relative border rounded-0 "
                    style={{
                      // overflow: "hidden",
                      // borderRadius: "10px",
                      color: "black",
                      // border: "1px solid rgba(30, 24, 24, 0.3)",
                      backgroundColor: "rgba(255,255,255,0.8)", // semi-transparent background
                      backdropFilter: "blur(10px)", // only the background is blurred
                    }}
                  >
                    <h5 className="fw-bold text-danger">Notes</h5>
                    <p className="text-muted" style={{ zIndex: 1 }}>{items.terms_and_conditions}</p>
                  </div>
                )}
              </div>
              <div className="modal-footer sticky-bottom">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SecondCard;
